var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 78,
    viewBox: "0 0 45 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7393 14.0099C20.0557 14.0099 22.7442 11.3214 22.7442 8.00493C22.7442 4.6885 20.0557 2 16.7393 2C13.4229 2 10.7344 4.6885 10.7344 8.00493C10.7344 11.3214 13.4229 14.0099 16.7393 14.0099Z",
    stroke: "#636365",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7837 43.7319C32.3886 43.6106 30.6902 43.7319 29.9624 44.945C28.8706 42.2155 26.0197 40.3352 25.4132 37.4237C25.2919 36.8171 25.2919 36.2712 25.2919 35.6646C25.2312 33.3597 25.1706 30.9941 25.1099 28.6892C25.1099 42.3975 25.0492 56.1057 25.0492 69.7533C25.0492 71.4516 24.9886 73.3926 23.7755 74.6057C22.5017 75.8795 20.5607 75.9402 18.741 75.9402C17.164 75.9402 15.5869 75.9402 14.0099 75.9402C12.9787 75.9402 11.8869 75.9402 10.9164 75.4549C9.82461 74.909 9.09674 73.7565 8.7328 72.5434C8.36887 71.3303 8.36887 70.1172 8.42953 68.8434C8.42953 62.8991 8.42953 56.9549 8.49018 50.9499C6.79182 51.1926 4.85083 51.4352 3.5164 50.2827C2.12131 49.1303 2 47.1286 2 45.3089C2 40.5171 2 35.7253 2 30.9335C2 29.2351 2.06066 27.4154 2.66721 25.8384C3.27377 24.2613 4.66886 22.9269 5.94263 21.8958C8.97543 19.4089 12.7967 17.9531 16.7394 17.9531C21.4099 17.9531 26.0804 19.9548 29.2345 23.3515C30.0837 24.2613 30.8722 25.2925 31.2361 26.5056C31.782 28.0827 31.6001 29.781 31.6001 31.4187C31.5394 35.604 32.3279 39.7286 33.8443 43.6106C33.8443 43.7319 33.8443 43.7319 33.7837 43.7319Z",
    stroke: "#636365",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42969 51.0751V28.875",
    stroke: "#636365",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7422 75.9396V49.7969",
    stroke: "#636365",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0958 53.9794V72.8433C42.0958 74.6024 40.8221 75.9974 39.245 75.9974H28.5696C26.9925 75.9974 25.7188 74.6024 25.7188 72.8433V53.9794C25.7188 53.2515 25.9614 52.5843 26.3253 52.0384C26.8712 51.2498 27.6597 50.7646 28.5696 50.7646H29.5401V47.9744C29.5401 47.1859 29.7827 46.458 30.2073 45.9121C30.6925 45.3056 31.3597 44.881 32.1483 44.8203C32.2089 44.8203 32.3302 44.8203 32.3909 44.8203H35.4237C37.0007 44.8203 38.2745 46.2154 38.2745 47.9744V50.7646H39.245C40.8221 50.7646 42.0958 52.2203 42.0958 53.9794Z",
    stroke: "#636365",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58.3516V70.786",
    stroke: "#636365",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6016 58.3516V70.786",
    stroke: "#636365",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyFriends);
export default __webpack_public_path__ + "static/media/familyFriends.5346e041.svg";
export { ForwardRef as ReactComponent };